module.exports = __webpack_public_path__ + "static/media/bipedge-footer-image.1be6c273.png";